module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("To Mate, especially this time, because Mate is like Skipper. He didn’t imagine himself a leader, but he became one because he loved the game. And to my three kids in soccer, because it’s part of their blood, and my one who took karate instead, because he still knows that feeling of belonging that a sport can give you.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And to Mary, who, when I pointed out that this story was Cinderella from the prince’s point of view and that Winter Ball was almost a pun, almost cried. Because yes. Everybody should have his or her own fairy tale, just for them, and a Happy Ever After.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6336d342","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0003.vue
// module id = 63
// module chunks = 0